import { render, staticRenderFns } from "./FormOtherEnderecos.vue?vue&type=template&id=73e7b086"
import script from "./FormOtherEnderecos.vue?vue&type=script&lang=js"
export * from "./FormOtherEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormOtherEnderecos.vue?vue&type=style&index=0&id=73e7b086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports